import { actionsFactory } from '../factory/actions';
import { getLastUpdated, NAME } from '../reducers/keyCutters';
import { KEY_CUTTERS_FETCH } from './constants';

export const { fetchKeyCutters } = actionsFactory({
    baseAction: KEY_CUTTERS_FETCH,
    name: NAME,
    lastUpdateSelector: getLastUpdated,
});
